// Takes a `string _with_ underscores` and replaces the underscores
// with spans that change the text's color. 
// Primarily for use as a child of <Heading>

import React from 'react';
import { css, useTheme } from "@emotion/react";
import { UpsunTheme } from "../themes";

import {
  HighlightStrongBgStrong,
} from "../../tokens/js/light"

import {
  HighlightStrongBgStrong as HighlightStrongBgStrongDark
} from "../../tokens/js/dark"

type TextWithHighlightProps = {
  orig: string,
}

const TextWithHighlight:React.FC<TextWithHighlightProps> = ({ orig }) => {
  const theme = useTheme() as UpsunTheme;

  const highlightStyle = css`
    color: ${theme.name === "light" ? HighlightStrongBgStrong : HighlightStrongBgStrongDark};
  `;

  const valuePropMatches = orig.match(/_(.*?)_/g);

  if (valuePropMatches) {
    let parts = [];
    let lastIndex = 0;
    
    valuePropMatches.forEach(match => {
      const matchIndex = orig.indexOf(match, lastIndex);
      
      // Add text before the match
      if (matchIndex > lastIndex) {
        parts.push(orig.slice(lastIndex, matchIndex));
      }
      
      // Add the highlighted match
      const cleanText = match.replaceAll("_", "");
      parts.push(
        <span key={matchIndex} css={highlightStyle}>
          {cleanText}
        </span>
      );
      
      lastIndex = matchIndex + match.length;
    });
    
    // Add any remaining text after the last match
    if (lastIndex < orig.length) {
      parts.push(orig.slice(lastIndex));
    }

    return <>{parts}</>;
  }
  else {
    return orig;
  }
};

export default TextWithHighlight;